import { render, staticRenderFns } from "./TgBelowCell.vue?vue&type=template&id=5cd0c04a"
import script from "./TgBelowCell.vue?vue&type=script&lang=js"
export * from "./TgBelowCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports